import { cloneElement, useState } from 'react';
import { m as motion, AnimatePresence } from 'framer-motion';
import { cx, css, etiColors, resetButtonStyle } from '@eti/styles';
import ConditionalWrapper from '../conditional_wrapper/ConditionalWrapper';
import Icon from '../icon/Icon';
import StackedIcon from '../stacked_icon/StackedIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const elementStyles = css`
  border-bottom: 1px dotted currentcolor;
  margin: 0;
  padding: 0.625rem 0;

  &:last-child {
    border: 0;
  }
`;
const headerStyles = css`
  align-items: center;
  display: flex;
  font-size: 0.875rem;
`;
const titleStyles = css`
  align-items: center;
  display: inline-flex;
  flex: 1;
  margin-right: 1px;
`;
const getIcon = (icon, iconStyles) => {
  const styles = size => css`
    height: ${size};
    margin-right: 0.5rem;
    width: ${size};

    [dir='rtl'] & {
      margin-left: 0.5rem;
      margin-right: 0;
    }

    /* stylelint-disable-next-line */
    ${iconStyles}
  `;
  if (typeof icon === 'string') {
    return /*#__PURE__*/_jsx(Icon, {
      className: styles('1rem'),
      color: etiColors.grayScale[8],
      "data-testid": `cart-${icon}-icon`,
      id: icon,
      size: "1rem"
    });
  }
  if (Array.isArray(icon)) {
    return /*#__PURE__*/_jsx(StackedIcon, {
      className: styles('1.25rem'),
      icons: icon
    });
  }
  return /*#__PURE__*/cloneElement(icon, {
    className: styles('1.25rem')
  });
};
const motionVariants = {
  initial: {
    opacity: 0
  },
  enter: {
    opacity: 1,
    transition: {
      type: 'tween',
      duration: 0.3
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0
    }
  }
};
const toggleStyles = isOpen => css`
  fill: #000;
  height: 10px;
  margin-inline-start: 6px;
  ${isOpen && 'transform: rotateX(180deg)'};
  width: 10px;
`;
const CartItem = _ref => {
  let {
    children: cartItemChildren,
    className,
    component: Component = 'div',
    dataTestId,
    hasToggle = false,
    icon,
    iconStyles,
    isOpenByDefault = false,
    priceDataTestId,
    price,
    title,
    ...props
  } = _ref;
  const [isOpen, setIsOpen] = useState(isOpenByDefault);
  const shouldHaveToggle = Boolean(hasToggle && cartItemChildren);
  const handleToggle = () => {
    setIsOpen(prevIsOpen => !prevIsOpen);
  };
  return /*#__PURE__*/_jsxs(Component, {
    ...props,
    className: cx('etiCartItem', elementStyles, className),
    "data-testid": dataTestId,
    children: [/*#__PURE__*/_jsx(ConditionalWrapper, {
      condition: shouldHaveToggle,
      wrapper: children => /*#__PURE__*/_jsx("button", {
        className: resetButtonStyle,
        onClick: handleToggle,
        style: {
          textAlign: 'left',
          width: '100%'
        },
        type: "button",
        children: children
      }),
      children: /*#__PURE__*/_jsxs("div", {
        className: headerStyles,
        children: [icon && getIcon(icon, iconStyles), title && /*#__PURE__*/_jsxs("div", {
          className: cx('cartItemTitle', titleStyles),
          "data-testid": `title-${dataTestId !== null && dataTestId !== void 0 ? dataTestId : priceDataTestId}`,
          children: [title, shouldHaveToggle && /*#__PURE__*/_jsx(Icon, {
            className: toggleStyles(isOpen),
            id: "chevron-down"
          })]
        }), price && /*#__PURE__*/_jsx("span", {
          className: "cart-cartItem-price",
          "data-testid": priceDataTestId,
          children: price
        })]
      })
    }), shouldHaveToggle ? /*#__PURE__*/_jsx(AnimatePresence, {
      children: isOpen && /*#__PURE__*/_jsx(motion.div, {
        animate: "enter",
        exit: "exit",
        initial: "initial",
        variants: motionVariants,
        children: cartItemChildren
      }, title)
    }) : cartItemChildren]
  });
};
export default CartItem;
//# sourceMappingURL=CartItem.js.map